import { render, staticRenderFns } from "./ResearcherAppliedMeasureCount.vue?vue&type=template&id=7a8be67f&scoped=true&"
import script from "./ResearcherAppliedMeasureCount.vue?vue&type=script&lang=js&"
export * from "./ResearcherAppliedMeasureCount.vue?vue&type=script&lang=js&"
import style0 from "./ResearcherAppliedMeasureCount.vue?vue&type=style&index=0&id=7a8be67f&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a8be67f",
  null
  
)

export default component.exports